export enum KeyWord {
    sourceId = 'sourceId',
    deviceId = 'deviceId',
    lineId = 'lineId',
    displayName = 'displayName',
    telemetryDDBprimaryKey = 'pk',
    telemetryDDBsortKey = 'eventTimestamp'
}
